
export default {
  name: "PencilSquareIcon",
  props: {
    mini: Boolean
  }
}
